import {getRemoteSavedItems} from '@gaia/utils/gaia/getSavedItems';
import {prefetchLazyAsyncList} from '@map/LazyAsyncList';
import DEFAULT_OPTIONS from '@map/sidebars/SavedItemsSidebar/DEFAULT_OPTIONS';
import memoize from 'lodash/memoize';

const prefetchSavedItemsSidebar = memoize(function prefetchSavedItemsSidebar(
    isAuthenticated: boolean
) {
    if (isAuthenticated) {
        prefetchLazyAsyncList(getRemoteSavedItems({...DEFAULT_OPTIONS, visibilities: {}}));
    }
});

export default prefetchSavedItemsSidebar;
